import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NbRoleProvider } from '@nebular/security';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class RoleProvider implements NbRoleProvider{
	role: string;
	constructor(private authService: NbAuthService) {
		this.authService.onTokenChange()
			.subscribe(
				(token: NbAuthJWTToken) => {
					this.role = token.isValid() ? 
						token.getPayload()['role'] || 'guest' 
					:
						'guest';
				},
			);
	}

	getRole(): Observable<string> {
		return of(this.role);
	}
}
